<template>
  <CCol
    sm="12"
    md="7"
    class="column"
    :class="{
      'column--main': column.isKey,
      'column--edit': column.edit,
      'column--ignored': column.state.key == 3,
    }"
  >
    <template v-if="error.length">
      <CAlert color="danger" v-for="(item, i) in error" closeButton :key="i">
        {{ item.msg }}
      </CAlert>
    </template>

    <CRow class="column__header d-flex bg-white">
      <CCol sm="12" md="5" class="column__title text-uppercase d-flex align-items-start">
        <p class="py-3 mt-1">{{ column.fileColumnName }}</p>
      </CCol>

      <CCol sm="12" md="7" class="column__type d-flex p-0 align-items-start">
        <CRow class="w-100" :gutters="false">
          <CCol class="d-flex p-0 column__type-wrapper align-items-start">
            <div v-if="isNewType || isDate" class="d-flex flex-column bg-white w-100 aliasColumn pt-3">
              <div v-if="isDate">
                <CSelect
                  :options="formatDateOptions"
                  :disabled="hasPredefinedDateFormatForced"
                  add-input-classes="border-input"
                  placeholder="Select the date format"
                  :value.sync="dateFormat"
                  :class="{ 'bg-gray-200': hasPredefinedDateFormatForced }"
                />
              </div>
              <div v-if="isNewType">
                <CInput
                  v-model="newType.value"
                  addInputClasses="text-uppercase border-input"
                  class="text-uppercase font-weight-normal"
                  placeholder="Type the name of the new numeric field"
                />
              </div>
              <div class="d-flex">
                <CButton
                  v-if="isNewType"
                  :disabled="!newType.value.length && (!isDate || isNewType || dateFormat !== null)"
                  @click="setNewType"
                  class="btn-primary m-1 font-weight-semi-bold text-white"
                >
                  {{ $t('audience.organize.audianceList.button.confirm') }}
                </CButton>
                <CButton
                  v-if="!isNewType && isDate"
                  :disabled="dateFormat === null"
                  @click="confirmDateFormat"
                  class="btn-primary m-1 font-weight-semi-bold text-white"
                >
                  {{ $t('audience.organize.audianceList.button.confirm') }}
                </CButton>
                <CButton @click="clear(true)" class="btn-outline-gray-500 m-1 font-weight-semi-bold">
                  {{ $t('audience.organize.audianceList.button.cancel') }}
                </CButton>
              </div>
            </div>
            <multiselect
              v-else
              :multiple="false"
              selectLabel="Select"
              deselectLabel="Deselect"
              class="multiselect--large multiselect--fieldTypes"
              :group-label="'value' || 'group'"
              group-values="types"
              :maxHeight="500"
              :group-select="false"
              :value="column.type"
              :options="optionsTypes"
              @select="selectDataType($event)"
              :placeholder="$t('audience.organize.audianceList.placeholder.selectType')"
              label="value"
              track-by="value"
            >
              <template slot="option" slot-scope="props" :data-cy="setAttr(props)">
                <div class="option__desc" :data-cy="setAttr(props)">
                  <template v-if="props.option.$isLabel">
                    <span class="multiselect__optionLabelGroup">{{ props.option.$groupLabel | removeCaracterSpecial }}</span>
                  </template>
                  <template>
                    <span class="option__title">{{ props.option.value }} </span>
                    <span v-if="props.option.dataType" class="option__title">({{ props.option.dataType.value }})</span>
                  </template>
                </div>
              </template>
            </multiselect>
            <CButton
              :disabled="column.type == null"
              class="column__btnMain flex-shrink-1"
              :class="{ 'column__btnMain--hasAudience': hasAudience }"
              @click="
                mainColumn({
                  fileColumnPosition: column.fileColumnPosition,
                  key: column.fileColumnName,
                  value: column.fileColumnName,
                })
              "
            >
              <i class="icon icon__key icon__keyGrayDark"></i>
            </CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <CRow class="column__lines d-flex bg-white" v-if="column.state.key !== 3" :class="{ 'column__lines--disabled': !column.edit }">
      <template v-if="column.lines.length">
        <CCol
          v-for="(line, i) in column.lines.slice(0, 5)"
          :key="i + column.fileColumnName"
          sm="12"
          class="column__line d-flex align-items-center"
        >
          <CInput v-if="column.key == ''" type="text" v-model="column.lines[i]" class="form-group--simple" placeholder="type here" />

          <p class="my-2 mx-3 p-3" v-if="column.lines[i] == ''"></p>
          <p class="my-2 mx-3" else>
            {{ column.lines[i] }}
          </p>
        </CCol>
      </template>
    </CRow>
  </CCol>
</template>

<script>
import { customLabel } from './../../mixins/index'
export default {
  name: 'AudienceListColumn',
  props: {
    column: {
      type: Object,
      required: true,
    },

    optionsTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      error: [],

      formatDateOptions: [
        { label: 'dd-mm-yyyy', value: 'dd-mm-yyyy' },
        { label: 'mm-dd-yyyy', value: 'mm-dd-yyyy' },
        { label: 'yyyy-dd-mm', value: 'yyyy-dd-mm' },
        { label: 'yyyy-mm-dd', value: 'yyyy-mm-dd' },
        { label: 'dd/mm/yyyy', value: 'dd/mm/yyyy' },
        { label: 'mm/dd/yyyy', value: 'mm/dd/yyyy' },
        { label: 'yyyy/dd/mm', value: 'yyyy/dd/mm' },
        { label: 'yyyy/mm/dd', value: 'yyyy/mm/dd' },
        { label: 'dd.mm.yyyy', value: 'dd.mm.yyyy' },
        { label: 'mm.dd.yyyy', value: 'mm.dd.yyyy' },
        { label: 'yyyy.dd.mm', value: 'yyyy.dd.mm' },
        { label: 'yyyy.mm.dd', value: 'yyyy.mm.dd' },
      ],
      newType: {
        group: '',
        value: '',
      },
      isDate: false,
      dateFormat: null,
      objAux: null,
    }
  },
  mixins: [customLabel],
  methods: {
    setLabel(obj) {
      return obj.Label
    },

    getGroupOptions(arr) {
      return arr.map((item) => {
        return {
          value: item.key,
          label: item.Label,
        }
      })
    },

    mainColumn(value) {
      this.$store.dispatch('audience/updateMainColumn', {
        event: 'click',
        position: value.fileColumnPosition,
      })
    },

    selectDataType(obj) {
      this.setColumnLikeKey(this.column.fileColumnPosition, obj)

      if (obj.dataType.value === 'DATETIME' || obj.dataType.value === 'DATE') {
        this.isDate = true
        this.objAux = obj
      } else {
        this.isDate = false
        this.objAux = null
      }

      this.dateFormat = this.hasPredefinedDateFormatForced ? this.column.predefinedFormat : null

      if (obj.group == 'new') {
        obj.hasName = false
        this.newType.key = this.qndFieldsCustom()
        this.newType.group = 'CUSTOM'
        this.newType.dataType = {
          key: obj.dataType.key,
          value: obj.dataType.value,
        }
        this.$store.dispatch('audience/updateTypeItem', {
          type: obj,
          position: this.column.fileColumnPosition,
          format: this.dateFormat,
        })
        return
      }

      this.$store.dispatch('audience/updateTypeItem', {
        type: obj,
        position: this.column.fileColumnPosition,
        format: this.dateFormat,
      })
    },

    setNewType() {
      this.error = []

      if (this.isDate) {
        this.newType.format = this.dateFormat
      }

      if (this.typeAlreadyExists()) {
        this.error.push({
          msg: this.$t('audience.customFields.table.message.name-type-already-exists'),
        })
        return
      }

      this.newType.hasName = true

      this.$store.dispatch('audience/updateTypeItem', {
        type: this.newType,
        new: true,
        position: this.column.fileColumnPosition,
        format: this.dateFormat,
      })
      this.clear()
    },

    confirmDateFormat() {
      if (this.objAux) {
        // this.objAux.format = this.dateFormat // Adiciona o formato de data ao objeto da coluna
        this.$store.dispatch('audience/updateTypeItem', {
          type: this.objAux,
          new: false,
          position: this.column.fileColumnPosition,
          format: this.dateFormat,
        })
        this.clear()
      }
    },

    typeAlreadyExists() {
      const allTypes = this.optionsTypes.reduce((acc, cur) => {
        return acc.concat(cur.types)
      }, [])

      return allTypes.some(
        (item) =>
          item.value.trim().toUpperCase() == this.newType.value.trim().toUpperCase() &&
          item.dataType.value.trim().toUpperCase() == this.newType.dataType.value.trim().toUpperCase(),
      )
    },

    setColumnLikeKey(position, obj) {
      const keyValue = obj.value

      if (this.audienceKeys.some((item) => item.value.toUpperCase() === keyValue.toUpperCase())) {
        this.$store.dispatch('audience/updateMainColumn', {
          event: 'click',
          position: position,
        })
        return
      }

      this.$store.dispatch('audience/removeMainColumn', { position: position })
    },

    clear(dispatch = false) {
      if (dispatch) {
        this.$store.dispatch('audience/updateTypeItem', {
          type: null,
          position: this.column.fileColumnPosition,
          format: this.dateFormat,
        })
      }

      this.newType = {
        group: '',
        value: '',
        hasName: false,
      }
      this.error = []
      this.dateFormat = null
      this.objAux = null
      this.isDate = false
    },
    qndFieldsCustom() {
      return this.optionsTypes.find((item) => item.value == 'CUSTOM').types.length + 1
    },
    setAttr(props) {
      if (props.option && props.option.dataType) {
        return props.option.group + '-' + props.option.dataType.key
      }

      return ''
    },
  },
  computed: {
    listNameColumns() {
      return this.$store.getters['audience/namesColumns']
    },

    isNewType() {
      return this.newType.group == 'CUSTOM'
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    },

    audienceKeys() {
      return this.$store.getters['audience/optionMainColumSelected']
    },

    hasPredefinedDateFormatForced() {
      return this.isDate && this.column.forcePredefinedDataFormat && this.column.predefinedFormat
    },
  },
}
</script>
<style lang="scss" scope>
.column {
  color: var(--gray-600);
  border: 1px solid transparent;
  transition: all 300ms ease-in-out;
  pointer-events: none;
  cursor: alias;

  &--main {
    border: 1px solid var(--primary);

    .column__btnMain {
      background: var(--primary);
      color: white;

      .icon__key {
        background: url(/img/icons/icon_key_white.svg);
        animation: bounce 400ms forwards;
      }
    }
  }

  &--edit {
    pointer-events: initial;
  }

  &--ignored {
    background: var(--gray-500);

    .multiselect {
      display: none;
    }

    .column__type-wrapper {
      justify-content: flex-end;
    }
  }

  &__header {
    height: 60px;
  }

  &__line {
    border-top: 2px solid #f5f5f5;
    min-height: 42px;
  }

  &__btnMain {
    background: #edeff1;
    color: var(--gray-600);
    height: 60px !important;
    width: 60px;

    &--hasAudience {
      cursor: not-allowed !important;
      pointer-events: none;
    }
  }

  .aliasColumn {
    z-index: 3;
    padding: 0 10px 10px 10px;
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.08);

    ::placeholder {
      font-size: 13px;
      text-transform: initial;
    }

    input.form-control:focus {
      box-shadow: inherit !important;
    }
  }

  .form-control {
    height: 60px;
  }

  .form-control:disabled,
  .form-control[readonly] {
    background-color: transparent;
    opacity: 1;
  }

  .column__lines {
    &--disabled {
      opacity: 0.5;
    }
  }
}

.multiselect {
  border-left: 2px solid #f5f5f5;

  &__option {
    color: var(--gray-700);
  }

  &__single {
    text-transform: uppercase;
  }

  &__optionLabelGroup {
    color: var(--gray-500);
    border-bottom: 1px solid var(--gray-500);
    display: block;
    margin: 10px 0;
    padding: 10px 0;
  }

  &__option--group {
    height: auto;
    background: none;
    padding: 10px;
    margin: 0;
    border-bottom: 1px solid var(--gray-500);
    text-transform: uppercase;
  }

  &__option--disabled {
    border: none;
    color: var(--gray-500);
  }

  &__content-wrapper {
    padding: 1em;
  }

  &--disabled {
    .multiselect__select {
      display: none !important;
    }
  }
}

.border-input {
  border: 1px solid $gray-300 !important;
  border-radius: 5px !important;
}
.border-input::placeholder {
  font-size: 14px;
}
</style>
